import { ParametrosLocalidade } from 'store/modules/api/sgu/loginUnico/types';

export const getApiKey = (parametros: ParametrosLocalidade[]) => {
	let api = 'NO API KEY';
	if (!parametros.length) {
		return api;
	}
	if (
		parametros.filter(
			(item: ParametrosLocalidade) => item.sigla === 'KEY_API_GOOGLE_MAPS',
		)
	) {
		const filterValue = parametros.filter(
			(item: ParametrosLocalidade) => item.sigla === 'KEY_API_GOOGLE_MAPS',
		);
		if (filterValue[0]?.valor) {
			api = filterValue[0]?.valor;
		}
		return api;
	}
	return api;
};
